import axios from 'axios'
import apiList from './resource.js'

export default {
  // 用户配置信息
  getUserInfo: function (successfn, errorfn) {
    return axios.get(apiList.user.getInfo)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 修改用户信息
  updateInfoPost: function (data, successfn, errorfn) {
    return axios.post(apiList.user.updateInfo, data)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 修改绑定手机号
  updateMobilePost: function (data, successfn, errorfn) {
    return axios.post(apiList.user.updateMobile, data)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 上传用户头像
  uploadAvatarPost: function (data, successfn, errorfn) {
    return axios.post(apiList.user.uploadAvatar, data)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 修改用户头像
  updateAvatarPost: function (data, successfn, errorfn) {
    return axios.post(apiList.user.updateAvatar, data)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 获取短信验证码
  getAuthCode: function (data, successfn, errorfn) {
    return axios.get(apiList.user.getAuthCode, {
      params: data
    })
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 消息中心列表查询
  msgList: function (successfn, errorfn) {
    return axios.get(apiList.user.msgList)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  // 实名认证
  certificationPost: function (data, successfn, errorfn) {
    return axios.post(apiList.user.certification, data)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  },
  orderList: function (data, successfn, errorfn) {
    return axios.post(apiList.user.orderList, data)
    .then(res => {
      successfn && successfn(res.data)
    })
    .catch(res => {
      errorfn && errorfn(res.data)
    })
  }
}



// WEBPACK FOOTER //
// ./src/fetch/user.js